// extracted by mini-css-extract-plugin
export default {"AltTextButton":"_AltTextButton--C8pm2","Popover":"_Popover--mQu9Q"};